import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useLayout } from '../../../contexts/LayoutContext';
import AppMenu from './appmenu';

import { useTranslation } from 'react-i18next';


const StyledAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: 3000,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.background.paper,
    transition: '0.3s ease-in-out',
    alignSelf: "flex-end",
    display: 'flex',
    height: '90px',
    justifyContent: 'center',
    boxShadow: "none",
    alignItems: "normal"
}));

const Header = React.memo(({ title }) => {
    const { t } = useTranslation();
    const [search, setSearch] = React.useState('');
    const { drawerWidth, toggleMobileMenu, isCollapsed, isMobile, pathname } = useLayout();
    const header_name = pathname === "/" ? "onlineCourses.onlineCourses" : ""

    return (
        <StyledAppBar key="header" position="sticky" sx={{ ml: { sm: 0, md: `${drawerWidth}px` }, width: `calc(100% - ${isMobile ? 0 : drawerWidth}px)`, px: { sm: "5px", md: "10px" } }} >
            <Toolbar key="toolbar" sx={{ gap: { xs: 1, md: 3 }, mt: "10px", justifyContent: "space-between" }}>
                <Typography variant="h4" color="#1A1A1A" gap={"15px"} fontWeight="600" flexDirection={"row"} alignItems={"center"}>{t(header_name)} </Typography>
                {/* {isMobile &&
                    <IconButton onClick={toggleMobileMenu} sx={{ color: 'black' }}>
                        <Image src={Hamburger} />
                    </IconButton>
                } */}
                {/* <SearchBar value={search} onChange={setSearch} /> */}
                <AppMenu />
            </Toolbar>
        </StyledAppBar>
    );
});

Header.propTypes = {
    onMenuClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
};

export default Header;